import React from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "@apollo/react-hooks";
import { Helmet } from "react-helmet";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

// types for photo type:
import { PhotoPurchaseType } from "js/graphql";

// components:
import LoadingSpinner from "core/LoadingSpinner";
import PhotoCheckout from "photos/PhotoCheckout";

// queries:
import { GET_CURRENT_PHOTO } from "photos/queries";

// variables:
const stripePromise = loadStripe(window._nounConfig.stripePublishable);

const PhotoCheckoutPage = () => {
    const { purchaseType, photoId } = useParams();
    const selectedLicense = purchaseType.toUpperCase();

    const { loading, error, data: { photoDetail: photo } = {} } = useQuery(
        GET_CURRENT_PHOTO,
        {
            variables: {
                photoId
            },
            fetchPolicy: "network-only"
        }
    );

    if (loading) {
        return <LoadingSpinner />;
    }

    return (
        <>
            <Helmet>
                <title>Checkout</title>
                <meta name="robots" content="noindex, nofollow" />
            </Helmet>
            <Elements stripe={stripePromise}>
                <PhotoCheckout
                    selectedLicense={selectedLicense}
                    photo={photo}
                />
            </Elements>
        </>
    );
};

export default PhotoCheckoutPage;
